const BasicLayout = () => <Outlet />

export default BasicLayout
